import animator from 'canvas-animator'
import TitleWord from './TitleWord'
import * as global from '../global'

const titleNames = [
  ['mei', 'ge', 'zhi', 'hui', 'gong', 'yi', 'bei', 'hou'],
  ['dou', 'you', 'ling', 'xi']
]

export default class Title extends animator.base.ShapeContainer {
  constructor (context = null, x = 0, y = 0) {
    super(context, x, y)
    this.words = []
    for (let i = 0; i < titleNames.length; i++) {
      const lineNames = titleNames[i]
      const wy = (i - titleNames.length / 2 + 0.5) * (TitleWord.height + Title.LINE_DELTA)
      for (let j = 0; j < lineNames.length; j++) {
        const wx = (j - lineNames.length / 2 + 0.5) * (TitleWord.width + Title.WORD_DELTA)
        const word = new TitleWord(context, wx, wy, lineNames[j])
        this.add(word)
        this.words.push(word)
      }
    }
    this._show = false
    this.showTime = 0
    this.next = 0
  }

  show () {
    if (!this._show) {
      this._show = true
    }
  }

  update (elapsed) {
    super.update(elapsed)
    if (this._show && this.next < this.words.length) {
      if (this.showTime >= this.next * Title.WORD_SHOW_TIME) {
        this.words[this.next].show = true
        this.next++
      }
      this.showTime += elapsed
    }
  }
}
Title.WORD_DELTA = -12 * global.scale
Title.LINE_DELTA = 8 * global.scale
Title.WORD_SHOW_TIME = 0.15
